module.exports = __webpack_public_path__ + "static/media/pay-tips-1.f1e78ebc.jpg";